export default "/imgs/users_icon.svg"